import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-check",
  "use": "svgIcon-check-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"svgIcon-check\"><path d=\"m16 0c-8.8 0-16 7.2-16 16s7.2 16 16 16 16-7.2 16-16-7.2-16-16-16m-2.5 23.4l-7.4-7.4 2.8-2.8 4.5 4.5 9.6-9.6 2.8 2.8-12.4 12.4\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol